import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-shujuzidian",
  "use": "icon-shujuzidian-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-shujuzidian\"><path d=\"M11.977 1.5c1.21 0 2.426.22 3.648.66A.573.573 0 0116 2.7v11.083a.571.571 0 01-.702.556 14.184 14.184 0 00-3.19-.359c-1.287 0-2.609.168-3.964.503a.551.551 0 01-.28-.002c-1.219-.334-2.47-.5-3.755-.5-1.113 0-2.252.125-3.416.375A.571.571 0 010 13.801V2.694c0-.24.15-.453.374-.536 1.19-.439 2.39-.658 3.598-.658 1.128 0 2.26.19 3.4.573l.427.151c.13.05.275.049.406-.001a10.416 10.416 0 013.772-.723zm-8 1.11c-1.159 0-2.033.203-2.621.607a.57.57 0 00-.247.465v9.727c1.151-.36 2.151-.54 3-.54.765 0 1.896.147 3.391.44V3.23l-.108-.038a10.577 10.577 0 00-3.415-.581zm8 0c-.768 0-1.926.22-3.476.658L8.5 13.29l.137-.032c1.183-.259 2.34-.388 3.472-.388 1.333 0 2.31.18 2.931.539V3.413c-1.193-.535-2.214-.802-3.063-.802z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/shujuzidian.svg
// module id = 507
// module chunks = 4